import { render, staticRenderFns } from "./accountForgotPassword.vue?vue&type=template&id=060eea35&"
import script from "./accountForgotPassword.vue?vue&type=script&lang=js&"
export * from "./accountForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports